export type VehicleType = 'car' | 'bike' | 'scooter' | 'bicycle';
export type ParkingType = 'driveway' | 'garage' | 'apartment' | 'commercial' | 'open_plot' | 'street';
export type AccessType = '24x7' | 'day_only' | 'time_restricted';
export type DurationType = 'hourly' | 'daily' | 'monthly';

export interface ParkingSpot {
  id: string;
  lat: number;
  lng: number;
  parking_type: ParkingType;
  vehicle_types: VehicleType[];
  capacity: number;
  price_hourly: number | null;
  price_daily: number | null;
  price_monthly: number | null;
  is_covered: boolean;
  security_features: string[];
  access_type: AccessType;
  access_hours: { from: string; to: string } | null;
  ev_charging: boolean;
  dimensions: string | null;
  building_name: string | null;
  description: string | null;
  interest_count: number;
  comment_count: number;
  created_at: string;
}

export interface SeekerPin {
  id: string;
  lat: number;
  lng: number;
  vehicle_types: VehicleType[];
  duration_needed: DurationType;
  budget_min: number | null;
  budget_max: number | null;
  requires_covered: boolean;
  requires_security: string[];
  requires_24x7: boolean;
  requires_ev: boolean;
  comment_count: number;
  created_at: string;
}

export interface RentPin {
  id: string;
  lat: number;
  lng: number;
  vehicle_type: VehicleType;
  parking_type: ParkingType;
  price_hourly: number | null;
  price_daily: number | null;
  price_monthly: number | null;
  is_covered: boolean;
  security_features: string[];
  comment_count: number;
  created_at: string;
}

export type CommentPinType = 'parking_spot' | 'seeker_pin' | 'rent_pin';

export interface PublicComment {
  id: string;
  pin_type: CommentPinType;
  pin_id: string;
  display_name: string | null;
  body: string;
  created_at: string;
}

export interface Filters {
  vehicle_type: VehicleType | '';
  parking_type: ParkingType | '';
  duration: DurationType | '';
  min_price: string;
  max_price: string;
  covered: boolean;
  security: string[];
  access_24x7: boolean;
  ev: boolean;
  free: 'any' | 'free' | 'paid';
}

export interface City {
  id: number;
  name: string;
  state: string;
  lat: number;
  lng: number;
  is_metro: boolean;
}

export type LocationSource = 'gps' | 'ip' | 'saved';

export interface UserLocation {
  lat: number;
  lng: number;
  source: LocationSource;
  savedAt: number;
}

export interface Viewport {
  center: [number, number];
  zoom: number;
}

export interface GeocodeResult {
  placeId: string;
  name: string;
  formattedAddress: string;
  lat: number;
  lng: number;
  types: string[];
}

export const VEHICLE_LABELS: Record<VehicleType, string> = {
  car: 'Car',
  bike: 'Bike',
  scooter: 'Scooter',
  bicycle: 'Bicycle',
};

export const PARKING_LABELS: Record<ParkingType, string> = {
  driveway: 'Driveway',
  garage: 'Garage',
  apartment: 'Apartment Slot',
  commercial: 'Commercial Lot',
  open_plot: 'Open Plot',
  street: 'Street Parking',
};

export const SECURITY_LABELS: Record<string, string> = {
  cctv: 'CCTV',
  guard: 'Security Guard',
  gated: 'Gated',
};

export const DURATION_LABELS: Record<DurationType, string> = {
  hourly: 'Hourly',
  daily: 'Daily',
  monthly: 'Monthly',
};
